import { Injectable } from '@angular/core';
import { SearchService } from './search/search.service';
import { SearchParams } from './search/models/search-params.model';
import { SearchStatus } from './search/models/search-status.model';
import { UserPreferenceService } from '../layout/home/services/user-preference.service';
import { ConfirmDialogService } from 'sce-core';
import { AlertService } from 'sce-core';
import { CoreServiceRegistry } from '../core/core-service-registry';
import { PrinterService } from './services/printer.service';
import { DocumentUtilService } from './services/document-util.service';
import { SavedSearchService } from './search/saved-search.service';
import { ButtonFactoryService } from './button/button-factory.service';
import { ValidatorService } from './services/validator.service';
import { LocalPagedSearchService } from './search/localpaged-search.service';
import { CrossFunctionalityNavigationService } from './services/cross-functionality-navigation.service';
import { LocalPagedDataManager } from './search/local-paged-data-manager.service';
import { FileUtilityService } from './services/file-utility.service';
import { ModalService } from './services/modal.service';
import { DatePickerConfigService } from './components/datepicker/datepicker-config.service';
import { JReportPrinterService } from './services/jreport-printer.service';

@Injectable()
export class SharedServiceRegistry {

    constructor(private coreServiceRegistry: CoreServiceRegistry,
        public savedSearchService: SavedSearchService, public userPreferencesService: UserPreferenceService,
        public confirmDialogService: ConfirmDialogService, public alertService: AlertService,
        public printerService: PrinterService, public documentUtilService: DocumentUtilService,
        public buttonFactoryService: ButtonFactoryService, public validatorService: ValidatorService,
        public crossFunctionalityNavigationService: CrossFunctionalityNavigationService,
        public localPagedDataManager: LocalPagedDataManager,
        public fileUtilityService: FileUtilityService,
        public sceModalService: ModalService,
        public dateConfigService: DatePickerConfigService,
        public jReportPrinterService: JReportPrinterService) {
    }

    public createSearchService(searchParams: SearchParams,
            searchStatus: SearchStatus): SearchService {
        let searchService: SearchService = null;
        if (searchParams.paginateLocally) {
            // For local pagination scenario, use LocalPagedSearchService
            searchService
                = new LocalPagedSearchService(this.coreServiceRegistry.http$,
                    searchParams,
                    searchStatus,
                    this.coreServiceRegistry.resourceService,
                    this.userPreferencesService,
                    this.alertService,
                    this.dateConfigService);
            searchService.setDataManager(this.localPagedDataManager);
        } else {
            searchService
                = new SearchService(this.coreServiceRegistry.http$,
                    searchParams,
                    searchStatus,
                    this.coreServiceRegistry.resourceService,
                    this.userPreferencesService,
                    this.alertService,
                    this.dateConfigService);
        }
        return searchService;
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/shared-service-registry.ts